import React from 'react'
const UserDataContext = React.createContext(null)
export default UserDataContext





// WEBPACK FOOTER //
// ./src/components/UserDataContext.js